/*
  Collapses the footer link columns into accordions on small screens.

  Progressive enhancement over Dawn's stock footer blocks: without JS every
  column renders fully expanded, and the desktop layout is never altered. The
  brand/social column is deliberately skipped so the logo and social icons stay
  visible on mobile.
*/
(function () {
  var MOBILE = '(max-width: 749px)';
  var panels = [];
  var mql = window.matchMedia(MOBILE);

  function setOpen(button, panel, open) {
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  }

  function sync() {
    panels.forEach(function (pair) {
      if (mql.matches) {
        setOpen(pair.button, pair.panel, false);
      } else {
        // Desktop: not a disclosure at all, so drop the state entirely.
        pair.button.removeAttribute('aria-expanded');
        pair.panel.hidden = false;
      }
    });
  }

  function enhance(block, index) {
    if (block.dataset.dnFooterAcc) return;

    var heading = block.querySelector('.footer-block__heading');
    var panel = block.querySelector('.footer-block__details-content');
    if (!heading || !panel) return;

    // Leave the brand/social column expanded.
    if (block.querySelector('.footer-block__brand-info')) return;

    block.dataset.dnFooterAcc = 'true';
    block.classList.add('dn-footer-acc');
    panel.classList.add('dn-footer-acc__panel');
    if (!panel.id) {
      panel.id = 'dn-footer-panel-' + index + '-' + Math.random().toString(36).slice(2, 7);
    }

    // Keep the h2 for document outline and put the control inside it.
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'dn-footer-acc__toggle';
    button.setAttribute('aria-controls', panel.id);
    while (heading.firstChild) {
      button.appendChild(heading.firstChild);
    }

    var icon = document.createElement('span');
    icon.className = 'dn-footer-acc__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML =
      '<svg viewBox="0 0 10 6" width="10" height="6" fill="none" focusable="false">' +
      '<path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    button.appendChild(icon);
    heading.appendChild(button);

    button.addEventListener('click', function () {
      if (!mql.matches) return;
      setOpen(button, panel, button.getAttribute('aria-expanded') !== 'true');
    });

    panels.push({ button: button, panel: panel });
  }

  function init() {
    var blocks = document.querySelectorAll('.footer__blocks-wrapper .footer-block');
    if (!blocks.length) return;
    Array.prototype.forEach.call(blocks, enhance);
    if (panels.length) sync();
  }

  if (mql.addEventListener) {
    mql.addEventListener('change', sync);
  } else if (mql.addListener) {
    mql.addListener(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the footer section on edit; re-enhance the new markup.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.footer__blocks-wrapper')) {
      panels = [];
      init();
    }
  });
})();
